import { render, staticRenderFns } from "./FAQCard.vue?vue&type=template&id=9e922682&"
import script from "./FAQCard.vue?vue&type=script&lang=js&"
export * from "./FAQCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports